import { Component, OnInit, OnDestroy, Compiler } from '@angular/core';
import { RouterLink, NavigationEnd, Router, Event, NavigationStart } from "@angular/router";
import { LocalStorageService } from 'ngx-webstorage';
import { SidebarService } from './sidebar.service';
import { Subscription } from 'rxjs/Subscription';
import { UserRolesService } from '../../common/user-roles.service';
import { environment } from '../../../environments/environment';

import PerfectScrollbar from 'perfect-scrollbar';
import { AuthService } from '../../auth/auth.service';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
  providers: [UserRolesService]
})
export class SidebarComponent implements OnInit, OnDestroy {

  sideRoutes = "dashboard";
  loginRole: any;
  subSideRoutes: string = null;
  subSideSubRoutes: string = null;
  ps;
  showModule:Object = environment.SHOW_MODULE;


  constructor(private storage: LocalStorageService, private sidebarService: SidebarService, private router: Router,
    private userRolesService: UserRolesService, private compiler: Compiler, private authService : AuthService) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart || event instanceof NavigationEnd) {

        this.compiler.clearCache();
        let eventUrl = event.url.split("/");
        this.sideRoutes = eventUrl[2];
        this.subSideRoutes = eventUrl[3] || null;
        this.subSideSubRoutes  = eventUrl[4] || null;
        //console.log("subside routes",this.subSideRoutes);
        //console.log("side routes",this.sideRoutes);
        if (this.sideRoutes != 'biller' &&  this.sideRoutes !=="errorMappingConfig" && this.sideRoutes !=="reports" && this.sideRoutes != "smsc-module" && this.sideRoutes != "campaignManagement" && this.sideRoutes != "benifitManagement" && this.sideRoutes != "promotionalCampaigns" && this.sideRoutes != "globalLimitManagement" && this.sideRoutes != "refferralManagement") {
          this.subOpen = '';
          this.subSideRoutes = '';
          //console.log("came here");
        }
        if(this.sideRoutes != "promotionalCampaigns"){
          this.subOpen1 = '';
          this.subSideSubRoutes = '';
        }
        if (this.sideRoutes != 'wallet-management') {
          localStorage.setItem('userSearchObj', '');
          localStorage.setItem('bonusSearchObj', '');
          localStorage.setItem('walletType', '');
        }
      }
    });
  }

  subOpen: string = '';
  openSub(active: string, sideRoutes): void {
    if(active !=this.subOpen && this.subOpen)
    this.subOpen=active;
    else
    this.subOpen = this.subOpen ? '' : active;
  }

  subOpen1: string = '';
  openSub1(active: string, sideRoutes): void {
    if(active !=this.subOpen1 && this.subOpen1)
    this.subOpen1=active;
    else
    this.subOpen1 = this.subOpen1 ? '' : active;
  }

  ngOnInit() {
    this.ps = new PerfectScrollbar('#sidebar');
    this.loginRole = this.userRolesService.getUserRoles();
  //  if(this.loginRole){
  //     this.loginRole ={"userId":"161","userName":"abhi","msisdn":"9815995236","email":"richa.gupta@spicelabs.in","status":"1","description":"Active","organizationType":"2","organization":"Paypro","department":null,"functionName":"CSE","organizationName":"Paypro","permissionRemarks":"Mobile no. change","permissionId":"222","roleName":"ADMIN","roleId":"1","billerMgt":"RW","brmsTestPad":"RW","walletManagement":"RW","serviceManagement":"RW","serviceGroupManagement":"RW","userGroupManagement":"RW","ruleSetManagement":"RW","hierarchyManagement":"RW","promocodeManagement":"RW","loginManagement":"RW","operations":"RW","notificationMgt":"RW","cashInMgt":"RW","limitCappingManagement":"RW","kycRequests":null}
  //     this.authService.userInfo = this.loginRole;
  //     console.log('sidebar--- if'+this.loginRole)
  //   }

  setTimeout(()=>{
    this.ps.update();
  },1000);
  }

  ngOnDestroy() {
  }


}



// WEBPACK FOOTER //
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/main/sidebar/sidebar.component.ts